module.exports = "/src/views/games/other/images/maps/map_6.png";